import React, { useState } from "react";
import {
    Box, Typography, Button,
    Checkbox,
} from "@mui/material";
import Footer from "../../Layout/Footer/footer";
import NavigationBar from "../../Layout/Header/header";





const MarkProject = () => {
    return (
        <>

            <Box sx={{ maxWidth: '2000px', margin: '0 auto' }}>
                <NavigationBar />
                <Box sx={{
                    py: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 },
                    px: { xs: 1, sm: 0.8, md: 2, lg: 4, xl: 6 },
                }}>

                    <Box sx={styles.mainContainer}>
                        <Box sx={styles.header}>
                            <Typography
                                sx={{
                                    fontSize: { xs: '20px', sm: '25px', md: '25px' },
                                    fontWeight: 500,
                                    lineHeight: { xs: 1.4, sm: 1.5, md: 1.6 }
                                }}
                            >
                                Contractor
                            </Typography>
                        </Box>


                        <Box sx={styles.mainBox}>
                            <Box sx={styles.borderBox}>
                                <Box sx={{ pt: { xs: 1, md: 3 }, px: { xs: 2, sm: 1, md: 2, lg: 6, xl: 10 }, }}>
                                    <Box sx={{ gap:1,display: 'flex', alignItems: 'center', margin: '-3px' }}>
                                        <Checkbox sx={{ color: 'black', '&.Mui-checked': { color: 'black' } }} />
                                        <Typography sx={{
                                            whiteSpace: "nowrap",
                                         
                                            overflow: "hidden",
                                            textOverflow: "ellipsis", fontSize: { xs: '14px', sm: '15px', md: '15px', lg: '16px', xl: '16px' }, color: '#212121', ml: '-3px'
                                        }}>Mark Project as Completed</Typography>
                                    </Box>
                                </Box>

                                <Box sx={styles.submitContainer}>
                                    <Button sx={styles.submitButton}>Update</Button>
                                </Box>

                            </Box>

                        </Box>
                    </Box>

                </Box>
                <Footer />
            </Box>
        </>
    );
};

export default MarkProject;

const styles = {
    mainContainer: {
        borderRadius: { xs: "10px", sm: "10px" },
        boxShadow: '0px 0px 3px 0px #00000033',
    },
    header: {
        background: "linear-gradient(90deg, #89652A 0%, #B69D74 100%)",
        color: "#fff",
        padding: { xs: "10px 12px", sm: "14px 20px", md: "16px 24px" },
        borderTopLeftRadius: { xs: "6px", sm: "8px" },
        borderTopRightRadius: { xs: "6px", sm: "8px" }
    },

    mainBox: {
        px: { xs: '13px', sm: '20px', md: '30px', lg: '50px' },
        py: { xs: '13px', sm: '15px', md: '20px', lg: '20px' },

    },
    borderBox: {
        borderRadius: '10px',
        border: '1px solid #2D2D2D33'

    },


    submitContainer: {
        display: 'flex',
        justifyContent: 'center',
        mb: 6,
        mt: 3
    },
    submitButton: {
        textTransform: 'capitalize',
        fontSize: { xs: '16px', md: '16px' },
        fontWeight: 600,
        borderRadius: '28px',
        color: 'white',
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        bgcolor: '#89652A',
        py: 0.9,
        px: { xs: 4, md: 6 }
    },
};

